import styled from "styled-components";
import {
  messageItemContentBottomAttachmentIconId,
  messageItemContentBottomId,
  messageItemContentBottomNumberOfAttachmentsId,
  messageItemContentBottomReadMoreId
} from "../testIds";
import { PaperClipIcon } from "@interstate/components/Icons";
import { EventResultEnum } from "@coxauto-ui/cxm/communications/interfaces";
import classNames from "classnames";

const StyledMessageItemContentBottom = styled.span`
  border-top: 1px solid #b2b2b2;
  display: flex;
  margin-top: 20px;
  margin-bottom: 7px;
  text-align: left;
  color: #005ba8;
  padding-top: 8px;
  padding-left: 15px;
  padding-right: 15px;
`;

const StyledMessageItemNumberOfAttachments = styled.div`
  display: flex;
  align-items: center;
`;

const StyledPaperClipIconContainer = styled.div`
  margin-right: 6px;
  display: flex;
`;

const StyledReadMore = styled.a`
  color: #005ba8;
  margin-left: auto;
  cursor: pointer;
  text-decoration: none;

  .disabled {
    color: #959595;
    cursor: not-allowed;
  }
`;

export interface MessageItemContentBottomProps {
  contentId: number | string;
  eventResult: EventResultEnum;
  numberOfAttachments: number;
}

export function MessageItemContentBottom({
  contentId,
  eventResult,
  numberOfAttachments
}: MessageItemContentBottomProps) {
  return (
    <StyledMessageItemContentBottom
      data-testid={messageItemContentBottomId + contentId}
    >
      {numberOfAttachments > 0 && (
        <StyledMessageItemNumberOfAttachments
          data-testid={
            messageItemContentBottomNumberOfAttachmentsId + contentId
          }
        >
          <StyledPaperClipIconContainer>
            <PaperClipIcon
              data-testid={messageItemContentBottomAttachmentIconId}
            />
          </StyledPaperClipIconContainer>
          {`${numberOfAttachments} Attachment(s)`}
        </StyledMessageItemNumberOfAttachments>
      )}
      <StyledReadMore
        className={classNames({
          disabled: eventResult === EventResultEnum.INPROGRESS
        })}
        data-testid={messageItemContentBottomReadMoreId}
      >
        Read More
      </StyledReadMore>
    </StyledMessageItemContentBottom>
  );
}

export default MessageItemContentBottom;
